import React from 'react';
import { Dialog, DialogPanel, DialogTitle, DialogBackdrop } from '@headlessui/react';
import { X } from 'lucide-react';
import './DialogSurface.css';

export function Modal({
  isOpen,
  onClose,
  title,
  children,
  width = 'max-w-lg',
  className = '',
}) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="app-dialog relative z-[100]">
      <DialogBackdrop
        transition
        className="app-dialog__backdrop fixed inset-0"
      />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel
          transition
          className={`app-dialog__panel relative w-full ${width} flex flex-col overflow-hidden ${className}`}
        >
          {title && (
            <div
              className="flex shrink-0 items-center justify-between px-6 py-4 border-b"
              style={{ borderColor: 'var(--color-border-primary)' }}
            >
              <DialogTitle
                className="app-dialog__title"
              >
                {title}
              </DialogTitle>
              <button
                onClick={onClose}
                type="button"
                className="app-dialog__close"
                aria-label="关闭"
                title="关闭"
              >
                <X size={18} />
              </button>
            </div>
          )}
          <div className="min-h-0 overflow-y-auto p-6">{children}</div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
